import { makeStyles, withStyles } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  card: {
    marginTop: '10px',
  },
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  container: {
    width: '48%',
    display: 'flex',
    justifyContent: 'space-between',
    margin: '5px',
    alignItems: 'center',
  },
  titles: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '16px',
    fontWeight: 'Bold',
    color: '#FAA500',
  },
  description: {
    fontFamily: 'Nunito, sans-serif',
    fontSize: '14px',
    fontWeight: 'Bold',
  },
  userContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    borderBottom: '1px solid #80808059',
  },
}));
